import {Action} from 'redux';
import {CONSOLE_CLEAR, CONSOLE_RESULT} from './constants';

export interface IConsoleAction extends Action {
  payload?: any;
}

export const consoleClear = (payload?: any) => ({
  type: CONSOLE_CLEAR,
  payload,
});

export const consoleResult = (payload) => ({
  type: CONSOLE_RESULT,
  payload,
});
